import { useApp } from '@libs/core';
import { CoreButtonView, type TCoreButtonStyleProps, type TCoreButtonViewProps } from '@core/widgets';
import React from 'react';
import { SemanticColor, semanticColors } from '../../../theme/colors';

type TCalculatorFeeButtonProps = {
    enterCodePopup: React.ReactNode;
    appliedCodePopup: React.ReactNode;
    handlingAutoApplied?: boolean;
    label: string;
    value?: string;
    parentStyleNames?: string[];
};

const codeButtonStyleProps: TCoreButtonStyleProps = {
    variant: 'outlined',
    surface: semanticColors[SemanticColor.FillSecondary],
    main: semanticColors[SemanticColor.TextEmphasised],
    borderRadius: 16,
    borderStroke: 1,
    outline: semanticColors[SemanticColor.BorderPrimary],
    fontStyle: { fontWeight: 500, fontSize: 14, lineHeight: 20 },
    padding: { top: 4, right: 16, bottom: 4, left: 16 },
    hovered: { surface: semanticColors[SemanticColor.FillSecondaryHovered] },
    pressed: { surface: semanticColors[SemanticColor.FillSecondaryPressed] },
};

const CodeButton = React.memo(({ enterCodePopup, appliedCodePopup, label, value, handlingAutoApplied, parentStyleNames }: TCalculatorFeeButtonProps) => {
    const { setPopup } = useApp();
    const handleClick = () => {
        setPopup(value || handlingAutoApplied ? appliedCodePopup : enterCodePopup);
    };
    const widget = { uid: '', data: { text: label }, options: {} } as TCoreButtonViewProps['widget'];
    return (
        <CoreButtonView
            widget={widget}
            text={label}
            styleName="calculatorCodeButton"
            parentStyleNames={parentStyleNames}
            styleProps={codeButtonStyleProps}
            onClick={handleClick}
        />
    );
});
export { CodeButton };
